import { Inject } from '@odinjs/odin';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FragmentNames, NfcsPainScaleAliases } from '../../../codegen';
import BaseController from '../../BaseController';
import './nfcs-pain-scale-controller.css';
import { Endpoint } from '../../../constants/endpoints';

@Controller({ fragment: FragmentNames.NFCS_PAIN_SCALE })
class NfcsPainScaleController extends BaseController {

  @Inject(NfcsPainScaleAliases.REFERENCE_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @Inject(NfcsPainScaleAliases.STRETCHED_MOUTH_RADIO_GROUP)
  strectchedMouthRadioGroupApi!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.PUCKERED_LIPS_RADIO_GROUP)
  puckeredLipsRadioGroupApi!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.HALF_OPEN_LIPS_RADIO_GROUP)
  halfOpenLipsRadioGroup!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.DEEPEN_NASOLABIAL_FOLD_RADIO_GROUP)
  deepenNasolabialFoldRadioGroupApi!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.SQUINTED_EYES_RADIO_GROUP)
  squintedEyesRadioGroupApi!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.CHIN_QUIVERING_RADIO_GROUP)
  chinQuiveringRadioGroupApi!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.TENSE_TONGUE_RADIO_GROUP)
  tenseTongueRadioGroupApi!: RadioGroupAPI;

  @Inject(NfcsPainScaleAliases.PROMINENT_FOREHEAD_RADIO_GROUP)
  prominentForeheadRadioGroupApi!: RadioGroupAPI;

  getNfcsScaleData(radioGroup: RadioGroupAPI): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const expressionId = 336100;

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      });
  }

  @OnMount({target: NfcsPainScaleAliases.STRETCHED_MOUTH_RADIO_GROUP})
  onMountStrectchedMouthForm(): void {
    this.getNfcsScaleData(this.strectchedMouthRadioGroupApi);
  }

  @OnMount({target: NfcsPainScaleAliases.PUCKERED_LIPS_RADIO_GROUP})
  onMountPuckeredLipsForm(): void {
    this.getNfcsScaleData(this.puckeredLipsRadioGroupApi);
  }

  @OnMount({target: NfcsPainScaleAliases.HALF_OPEN_LIPS_RADIO_GROUP})
  onMountHalfOpenLipsForm(): void {
    this.getNfcsScaleData(this.halfOpenLipsRadioGroup);
  }

  @OnMount({target: NfcsPainScaleAliases.DEEPEN_NASOLABIAL_FOLD_RADIO_GROUP})
  onMountDeepenNasolabialFoldForm(): void {
    this.getNfcsScaleData(this.deepenNasolabialFoldRadioGroupApi);
  }

  @OnMount({target: NfcsPainScaleAliases.SQUINTED_EYES_RADIO_GROUP})
  onMountSquintedEyesForm(): void {
    this.getNfcsScaleData(this.squintedEyesRadioGroupApi);
  }

  @OnMount({target: NfcsPainScaleAliases.CHIN_QUIVERING_RADIO_GROUP})
  onMountChinQuiveringForm(): void {
    this.getNfcsScaleData(this.chinQuiveringRadioGroupApi);
  }

  @OnMount({target: NfcsPainScaleAliases.TENSE_TONGUE_RADIO_GROUP})
  onMountTenseTongueForm(): void {
    this.getNfcsScaleData(this.tenseTongueRadioGroupApi);
  }

  @OnMount({target: NfcsPainScaleAliases.PROMINENT_FOREHEAD_RADIO_GROUP})
  onMountProminentForeheadForm(): void {
    this.getNfcsScaleData(this.prominentForeheadRadioGroupApi);
  }

  @OnClose({ target: NfcsPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE })
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: NfcsPainScaleAliases.REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: NfcsPainScaleAliases.PROMINENT_FOREHEAD_FORM })
  onClickCancel(): void {
    ModalService.close(FragmentNames.NFCS_PAIN_SCALE);
  }

  @OnBeforeSubmit({ target:  NfcsPainScaleAliases.PROMINENT_FOREHEAD_FORM })
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.strectchedMouthRadioGroupApi?.getValue()?.value)
                      + Number(this.puckeredLipsRadioGroupApi?.getValue()?.value)
                      + Number(this.halfOpenLipsRadioGroup?.getValue()?.value)
                      + Number(this.deepenNasolabialFoldRadioGroupApi?.getValue()?.value)
                      + Number(this.squintedEyesRadioGroupApi?.getValue()?.value)
                      + Number(this.chinQuiveringRadioGroupApi?.getValue()?.value)
                      + Number(this.tenseTongueRadioGroupApi?.getValue()?.value)
                      + Number(this.prominentForeheadRadioGroupApi?.getValue()?.value));
    ModalService.close(FragmentNames.NFCS_PAIN_SCALE);
  }
}
export default NfcsPainScaleController;
